import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SafeUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ColDef, ColumnApi, GridApi, GridReadyEvent, RowClickedEvent } from 'ag-grid-community';
import { data } from 'jquery';
import { AlertService } from 'src/app/_services/alert.service';
import { BtnCellRenderer } from 'src/app/common/button-cell-renderer.component';
import Swal from 'sweetalert2'
import { ServiceProviderType } from '../service-provider-type';
import { DatepickerCellRenderer } from 'src/app/common/datepicker-cell-renderer.component';
import { InputCellRenderer } from 'src/app/common/input-cell-renderer.component';
import { SelectCellRenderer } from 'src/app/common/select-cell-renderer.component';
import { AmountInputCellRenderer } from 'src/app/common/amount-input-cell-renderer.component';
import * as moment from 'moment';
import { ProductSubCategoryService } from '../../product-subcategory-management/product-subcategory-service';
import { ProductService } from '../product-service';

export class MaxAmountList {
  "id": number;
  "country": String;
  "countryName": String;
  "maxAmount": String;
  "updatedBy": String;
  "updatedOn": String;
  "approvedBy": String;
  "approvedOn": String;
}

export class CountryAmountMapping {
  "countryName" : String;
  "country": String;
  "maxAmount": number;
}

export class TypeDataTable {
  "id": number;
  "fromAmount": number;
  "toAmount": number;
  "serviceChargeType": String;
  "serviceCharge": number;
  "vatType": String;
  "vat": number;
  "effectiveUpdatedDate": String;
  "updatedBy": String;
  "updatedOn": String;
  "approvedBy": String;
  "aprrovedOn": String;
  "isAmountDisabled": Boolean;
  "showEditButton": Boolean;
  "isDatepickerDisabled": Boolean;
  "isSelectDisabled": Boolean;
  "type":string;
}

@Component({
  selector: 'app-product-add',
  templateUrl: './product-add.component.html',
  styleUrls: ['./product-add.component.scss']
})
export class ProductAddComponent implements OnInit {

  private gridApi: GridApi;
  private columnApi: ColumnApi;
  private gridApiDirect: GridApi;
  private gridApiSlab: GridApi;
  activeTab: any = "product";
  selectedFile: SafeUrl = 'assets/images/product.png';
  submitted: boolean = false;
  submittedCommission: boolean = false;
  addProductForm: FormGroup;
  addCommissionForm: FormGroup;
  maximumAmount: boolean = false;
  maximumAmountText: String;
  typeArray: String[];
  selectedDirect: boolean = false;
  selectedSlab: boolean = false;
  showOnlySpecific : boolean =false;
  public maxAmountData !: any[];
  public directData: any[];
  public slabData: any[];
  amount: boolean = true;
  maxdata: MaxAmountList;
  countryAmount: CountryAmountMapping;
  countryAmountList: any[];
  idCount: number = 1;
  directTypeData: TypeDataTable;
  slabTypeData: TypeDataTable;
  commissionSlabData: any[];
  categoryDropdownList: any[];
  subCategoryDropdownList: any[];
  countryDropDown : any[];
  categoryName : any;
  subCategoryName : any;
  showAddDirectSlabButton : boolean = false;
  saveButtonVisible : boolean = false;

  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 210,
    resizable: true,
    sortable: true,
    filter: false,
    autoHeight: true
  };

  public columnDefs: ColDef[] = [
    {
      field: 'fromAmount',lockVisible:true,  headerName: 'From Amount', editable: false, cellRenderer: AmountInputCellRenderer,
    },
    {
      field: 'toAmount',lockVisible:true,  headerName: 'To Amount', resizable: true, cellRenderer: AmountInputCellRenderer, onCellValueChanged: (params: any) => {
        const toAmountValue = parseFloat(params.newValue);
        const maxAmountValue = parseFloat(this.addCommissionForm.value.maxAmount);
        if (!isNaN(toAmountValue) && toAmountValue < maxAmountValue) {
          const nextRowVal = this.gridApiSlab.getDisplayedRowAtIndex(params.node.rowIndex + 1)!.data;
          const rowNode = this.gridApiSlab.getRowNode((params.node.rowIndex + 1).toString());
          if (rowNode) {
            const nextFromAmount = parseFloat((toAmountValue + 0.01).toFixed(2));
            this.slabData[params.node.rowIndex + 1].fromAmount = nextFromAmount;
            const newData = { ...rowNode.data, fromAmount: nextFromAmount };
            rowNode.setData(newData);
            this.gridApiSlab.refreshCells({ rowNodes: [rowNode], force: true });
          }
        }
      }
    },
    {
      field: 'serviceChargeType',lockVisible:true,  headerName: 'Service Charge Type', cellRenderer: SelectCellRenderer, cellEditorParams: {
        options: [
          { value: 'FLAT', label: 'FLAT' },
          { value: 'PERCENTAGE', label: 'PERCENTAGE' },
        ]
      }, onCellValueChanged: (params: any) => {
        const rowNode = this.gridApiSlab.getRowNode((params.node.rowIndex).toString());
        if (rowNode) {
          this.slabData[params.node.rowIndex].serviceChargeType = params.newValue
        }
      }
    },
    { field: 'serviceCharge',lockVisible:true,  headerName: 'Service Charge', cellRenderer: InputCellRenderer },
    // {
    //   field: 'vatType',lockVisible:true,  headerName: 'VAT Type', cellRenderer: SelectCellRenderer, cellEditorParams: {
    //     options: [
    //       { value: 'PERCENTAGE', label: 'PERCENTAGE' },
    //       { value: 'FLAT', label: 'FLAT' },
    //     ]
    //   }, onCellValueChanged: (params: any) => {
    //     const rowNode = this.gridApiSlab.getRowNode((params.node.rowIndex).toString());
    //     if (rowNode) {
    //       this.slabData[params.node.rowIndex].vatType = params.newValue;
    //       this.slabData[params.node.rowIndex].vat = 5;
    //       const newData = { ...rowNode.data, vatType: params.newValue, vat: 5 };
    //       rowNode.setData(newData);
    //       this.gridApiSlab.refreshCells({ rowNodes: [rowNode], force: true });
    //     }
    //   }
    // },
    { field: 'vat',lockVisible:true,  headerName: 'VAT', cellRenderer: InputCellRenderer },
    { field: 'id', headerName: 'ID', hide: true },
    {
      field: 'effectiveUpdatedDate',lockVisible:true,  headerName: 'Effective Update Date', cellRenderer: DatepickerCellRenderer, onCellValueChanged: (params: any) => {
        this.slabData.map((_: any, i: number) => {
          _.effectiveUpdatedDate = moment(params.newValue, ['YYYY-MM-DD HH:mm']).format("MM-DD-YYYY HH:mm");
        })
        this.gridApiSlab.setRowData(this.slabData);
      }
    },
  ];

  public columnDefsDirectSlab: ColDef[] = [
    {
      field: 'fromAmount',lockVisible:true,  headerName: 'From Amount', editable: false , cellRenderer: AmountInputCellRenderer,
    },
    {
      field: 'toAmount',lockVisible:true,  headerName: 'To Amount', editable: false, resizable: true, cellRenderer: AmountInputCellRenderer, onCellValueChanged: (params: any) => {
        const toAmountValue = parseFloat(params.newValue);
        const maxAmountValue = parseFloat(this.addCommissionForm.value.maxAmount);
        if (!isNaN(toAmountValue) && toAmountValue < maxAmountValue) {
          const nextRowVal = this.gridApiSlab.getDisplayedRowAtIndex(params.node.rowIndex + 1)!.data;
          const rowNode = this.gridApiSlab.getRowNode((params.node.rowIndex + 1).toString());
          if (rowNode) {
            const nextFromAmount = parseFloat((toAmountValue + 0.01).toFixed(2));
            this.directData[params.node.rowIndex + 1].fromAmount = nextFromAmount;
            const newData = { ...rowNode.data, fromAmount: nextFromAmount };
            rowNode.setData(newData);
            this.gridApiSlab.refreshCells({ rowNodes: [rowNode], force: true });
          }
        }
      }
    },
    {
      field: 'serviceChargeType',lockVisible:true,  headerName: 'Service Charge Type', cellRenderer: SelectCellRenderer, cellEditorParams: {
        options: [
          { value: 'FLAT', label: 'FLAT' },
          { value: 'PERCENTAGE', label: 'PERCENTAGE' },
        ]
      }, onCellValueChanged: (params: any) => {
        const rowNode = this.gridApiSlab.getRowNode((params.node.rowIndex).toString());
        if (rowNode) {
          this.directData[params.node.rowIndex].serviceChargeType = params.newValue
        }
      }
    },
    { field: 'serviceCharge',lockVisible:true,  headerName: 'Service Charge', cellRenderer: InputCellRenderer },
    // {
    //   field: 'vatType',lockVisible:true,  headerName: 'VAT Type', cellRenderer: SelectCellRenderer, cellEditorParams: {
    //     options: [
    //       { value: 'PERCENTAGE', label: 'PERCENTAGE' },
    //       { value: 'FLAT', label: 'FLAT' },
    //     ]
    //   }, onCellValueChanged: (params: any) => {
    //     const rowNode = this.gridApiSlab.getRowNode((params.node.rowIndex).toString());
    //     if (rowNode) {
    //       this.directData[params.node.rowIndex].vatType = params.newValue;
    //       this.directData[params.node.rowIndex].vat = 5;
    //       const newData = { ...rowNode.data, vatType: params.newValue, vat: 5 };
    //       rowNode.setData(newData);
    //       this.gridApiSlab.refreshCells({ rowNodes: [rowNode], force: true });
    //     }
    //   }
    // },
    { field: 'vat',lockVisible:true,  headerName: 'VAT', cellRenderer: InputCellRenderer },
    { field: 'id', headerName: 'ID', hide: true },
    {
      field: 'effectiveUpdatedDate',lockVisible:true,  headerName: 'Effective Update Date', cellRenderer: DatepickerCellRenderer, onCellValueChanged: (params: any) => {
        this.directData.map((_: any, i: number) => {
          _.effectiveUpdatedDate = moment(params.newValue, ['YYYY-MM-DD HH:mm']).format("MM-DD-YYYY HH:mm");
        })
        this.gridApiSlab.setRowData(this.directData);
      }
    },

  ];

  public maximumRatesCol: ColDef[] = [
    { field: 'countryName',lockVisible:true,  headerName: 'Country', cellClass: 'grid-cell-centered' },
    { field: 'maxAmount',lockVisible:true,  headerName: 'Maximum Product Amount', resizable: true, cellRenderer: 'agGroupCellRenderer' },
    { field: 'id', headerName: 'ID', hide: true },
    { field: 'updatedBy',lockVisible:true,  headerName: 'Updated By', },
    { field: 'updatedOn',lockVisible:true,  headerName: 'Updated On' },
    { field: 'approvedBy',lockVisible:true,  headerName: 'Approved By', },
    { field: 'approvedOn',lockVisible:true,  headerName: 'Approved On', },
    {
      field: 'actions',lockVisible:true,  headerName: 'Actions', width: 180, cellRenderer: BtnCellRenderer, cellRendererParams: [
        {
          clicked: async (event: any, param: any) => {

            console.log(param.data.id);
            this.deleteRow(param.data.id);
          },
          buttonIconClass: 'icon-delete'
        },
      ]
    }
  ];




  columnDefsCopy: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];
  tableSelectedColumn: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];
  tableSelectedColumnDirect: ColDef[] = [...(this.columnDefsDirectSlab.filter((col) => !col?.hide))];
  tableSelectedColumn1: ColDef[] = [...(this.maximumRatesCol.filter((col) => !col?.hide))];

  constructor(private router: Router, private formBuilder: FormBuilder, private alertService: AlertService, private subCategoryService: ProductSubCategoryService, private productService: ProductService) { }

  ngOnInit(): void {
    this.countryAmountList = [];
    this.maxAmountData = [];
    this.addProductForm = this.formBuilder.group({
      productImage: ['', Validators.required],
      productName: ['', Validators.required],
      productDesc: ['', Validators.required],
      productCode: ['', Validators.required],
      creditType: [''],
      category: [null, Validators.required],
      subCategory: [null, Validators.required],
      status: [null],
      countryProduct: [null]

    })

    this.subCategoryService.getCategoryDropdown().subscribe((response: any) => {
      this.categoryDropdownList = response.response.data;
    })

    this.productService.getCountryDropdown().subscribe((response:any)=>{
      console.log(response);
      this.countryDropDown = response.response.data;
    })

    this.addCommissionForm = this.formBuilder.group({
      country: [null, Validators.required],
      maxAmount: ['', Validators.required],
      type: ['', Validators.required]
    })

  }

  removeFile() {
    this.selectedFile = 'assets/images/product.png';
    this.addProductForm.get('productImage')?.reset();
  }

  cancelButton() {
    this.router.navigateByUrl('/productManagement/productList')
  }

  categoryChange(category: any) {
    this.categoryName = "";
    if(category == undefined){
      this.addProductForm.controls.subCategory.setValue(null);
      return;
    }
    this.subCategoryDropdownList = [];
    console.log(category.id);
    this.categoryName = category.name;
    this.productService.getSubCategoryDropdownById(category.id).subscribe((response: any) => {
      this.subCategoryDropdownList = response.response.data;
      this.addProductForm.controls.subCategory.setValue(null);
    });

  }

  subCategoryChange(subCategory:any){
    this.subCategoryName = "";
    if(subCategory == undefined){
      return;
    }
    console.log(subCategory.name);
    this.subCategoryName = subCategory.name;
  }

  addProduct(data: any) {
    this.submitted = true;
    if(this.addProductForm.valid){
    console.log("Valid");
    console.log("Profile :" + this.addProductForm.value.productImage);
    console.log("Add Data :" + JSON.stringify(data));

    if (!this.addProductForm.value.creditType) {
      this.addProductForm.value.creditType = false;
    }
    console.log(this.addProductForm.value.creditType);

    if (this.maxAmountData.length == 0) {
      this.alertService.errorAlertWithMessage("Please set country amount mapping");
      return;
    }
    this.activeTab = "commission";
    console.log(JSON.stringify(this.countryAmountList));
    }else{
      console.log("Not Valid");
    }
  }

  addCommission(data: any) {
    this.submittedCommission = true
    if (this.addCommissionForm.valid && this.addProductForm.valid) {
      if (this.directData.length != 0) {
        console.log(data);
        console.log("Commsion Datatable for Direct : " + JSON.stringify(this.directData));
        this.commissionSlabData = JSON.parse(JSON.stringify(this.directData));
      } else if (this.slabData.length != 0) {
        console.log(data);
        console.log("Commsion Datatable for Slab : " + JSON.stringify(this.slabData));
        this.commissionSlabData = JSON.parse(JSON.stringify(this.slabData));
      }else if (this.directData.length == 0){
        Swal.fire("Please set the slabs",'','error');
        return;
      }else if (this.slabData.length == 0){
        Swal.fire("Please set the slabs",'','error');
        return;
      }
      this.commissionSlabData.map((_: any) => {
        delete _.isAmountDisabled;
        delete _.type;
      })

      let commissionRequest = {
        "country": this.addCommissionForm.value.country,
        "type": this.addCommissionForm.value.type,
        "typeBody": this.commissionSlabData,
      }

      let requestForm = {
        "name": this.addProductForm.value.productName,
        "description": this.addProductForm.value.productDesc,
        "productCode": this.addProductForm.value.productCode,
        "creditType": this.addProductForm.value.creditType,
        "category": this.addProductForm.value.Category,
        "subCategory": this.addProductForm.value.subCategory,
        "productCountryMapping": this.countryAmountList,
        "productSlab": commissionRequest,
      };

      var requestData = new FormData();
      requestData.append("icon", this.addProductForm.value.productImage);
      requestData.append("request", JSON.stringify(requestForm));
      console.log(requestData);
      this.productService.saveProduct(requestData).subscribe((response: any) => {
        console.log(response);
        if (response.response.status == 200) {
          Swal.fire(response.response.message, '', 'success').then((result)=>{
            if (result.isConfirmed) {
              this.router.navigate(['/productManagement/productList']);
            } 
          });
        } else {
          Swal.fire(response.response.message, '', 'error');
          return;
        }
      })
    } else {
      console.log("Not Valid");
      return;
    }

  }

  typeButton() {
    if (this.addProductForm.valid) {
      console.log("Valid");
    } else {
      console.log("Not Valid");
    }

  }
  setProductProfile(profile: any) {
    console.log("Choose File Clicked");
    var file = profile.target.files[0];
    if(file.size > 50000){
      console.log("Greater than 50 KB");
      Swal.fire('Icon size cannot be greater than 50 KB','','error');
      return;
    }
    profile.target.value = '';
    this.addProductForm.get('productImage')?.setValue(file);
    var reader = new FileReader();
    reader.onloadend = this.handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);

  }

  handleReaderLoaded(e: any) {
    let reader = e.target;
    this.selectedFile = reader.result;
    console.log("Image Data : " + reader.result);
  }

  switchTab(tab: string): void {
        this.activeTab = tab;
  }

  async countryProductSelect(data:any) {
    if(data == undefined){
      return;
    }
    this.maxdata = new MaxAmountList;
    this.countryAmount = new CountryAmountMapping;
    console.log("Selected Product Country : " + this.addProductForm.value.countryProduct);
    if (this.addProductForm.value.countryProduct != "" && data.id != null) {
      for (let i: number = 0; i < this.maxAmountData.length; i++) {
        if (this.maxAmountData[i].countryName == data.name) {
          this.alertService.errorAlertWithMessage("Please select different country");
          return;
        }
      }
      let inputMaxAmount: HTMLInputElement
      await Swal.fire({
        title: "Please enter the Maximum Amount for " + data.name,
        html: '<input type="text" class="swal2-input" id="maxAmount" placeholder="Enter Max Amount (e.g., 9999.50)" maxlength="15">',
        confirmButtonText: '<span id="confirm-button-text">ADD</span>',
        showCancelButton: true,
        reverseButtons: false,
        allowOutsideClick : false,
        confirmButtonColor: '#f56d1d',
        cancelButtonColor: '#d33',
        customClass: {
          confirmButton: 'swal2-confirm-custom',
          cancelButton: 'swal2-cancel-custom'
        },
        didOpen:()=>{
          const popup = Swal.getPopup()!
          inputMaxAmount = popup.querySelector('#maxAmount') as HTMLInputElement
          if (inputMaxAmount) {
            inputMaxAmount.style.width = '90%';
            inputMaxAmount.style.maxWidth = '350px';
            inputMaxAmount.style.padding = '10px';
            inputMaxAmount.style.fontSize = '16px';
          }
          inputMaxAmount.onkeyup = (event) => event.key === 'Enter' && Swal.clickConfirm()
          inputMaxAmount.oninput = (event) => {
            const value = (event.target as HTMLInputElement).value;
            const decimalRegex = /^\d*\.?\d{0,2}$/;
            if (value && !decimalRegex.test(value)) {
              (event.target as HTMLInputElement).value = value.slice(0, -1);
            }
          }
        },
        preConfirm: () => {
          console.log(inputMaxAmount.value);
          if(inputMaxAmount.value != ""){
            const value = inputMaxAmount.value.trim();
            const decimalRegex = /^\d+(\.\d{1,2})?$/;
            if (!decimalRegex.test(value)) {
              this.alertService.toastWarringMessageAlertWithMessage("Please enter a valid amount with up to 2 decimal places");
              return;
            }
            const numValue = parseFloat(value);
            if (isNaN(numValue) || numValue <= 0) {
              this.alertService.toastWarringMessageAlertWithMessage("Please enter a valid positive amount");
              return;
            }
            this.maxdata.id = this.idCount;
            this.maxdata.maxAmount = value;
            this.maxdata.country = data.id;
            this.maxdata.countryName = data.name;
            this.maxdata.updatedBy = "";
            this.maxdata.updatedOn = "";
            this.maxdata.approvedBy = "";
            this.maxdata.approvedOn = "";
            this.idCount++;
            this.countryAmount.countryName = data.name;
            this.countryAmount.country = data.id;
            this.countryAmount.maxAmount = numValue;
            this.countryAmountList.push(this.countryAmount);
            this.maxAmountData.push(this.maxdata);
            console.log(JSON.stringify(this.maxAmountData));
            this.gridApi.setRowData(this.maxAmountData);
            console.log(this.countryAmountList[0].country);
            this.addProductForm.controls.countryProduct.setValue(null);
          }else{
            this.alertService.toastWarringMessageAlertWithMessage("Please enter max amount");
            return;
          }
        }
      });
    }

  }

  countrySelect() {
    this.maximumAmount = false;
    this.selectedDirect = false;
    this.selectedSlab = false;
    this.saveButtonVisible = false;
    this.addCommissionForm.controls.type.setValue("");
    this.maximumAmount = false;
    console.log("Selected Country : " + this.addCommissionForm.value.country);
    if (this.addCommissionForm.value.country != "" && this.addCommissionForm.value.country != null) {
      console.log("country change");
      this.maximumAmount = true;
      console.log("Country amount : " + this.countryAmountList);
      for (let i: number = 0; i < this.countryAmountList.length; i++) {
        if (this.countryAmountList[i].country == this.addCommissionForm.value.country) {
          this.addCommissionForm.controls.maxAmount.setValue(this.countryAmountList[i].maxAmount);
        }
      }
      console.log(this.addCommissionForm.value.maxAmount);
    }

  }

  keyFunc(amount: any) {
    this.amount = true;
    console.log(amount.target.value);
    if (amount.target.value) {
      console.log("DATA PRESENT")
      this.amount = false;
    }
  }

  isNumber(input: any) {
    var pattern = /^[0-9]+$/;
    return pattern.test(input);
  }

  // Method to validate product code input (only alphanumeric and underscore allowed)
  onProductCodeKeyPress(event: any): boolean {
    const charCode = event.which || event.keyCode;
    const char = String.fromCharCode(charCode);
    
    // Allow: backspace, delete, tab, escape, enter
    if ([8, 9, 27, 13, 46].indexOf(charCode) !== -1) {
      return true;
    }
    
    // Allow: alphanumeric characters (a-z, A-Z, 0-9) and underscore (_)
    const pattern = /^[a-zA-Z0-9_]$/;
    if (!pattern.test(char)) {
      event.preventDefault();
      return false;
    }
    
    return true;
  }

  // Method to validate product name input (alphanumeric, underscore, and spaces allowed)
  onProductNameKeyPress(event: any): boolean {
    const charCode = event.which || event.keyCode;
    const char = String.fromCharCode(charCode);
    
    // Allow: backspace, delete, tab, escape, enter
    if ([8, 9, 27, 13, 46].indexOf(charCode) !== -1) {
      return true;
    }
    
    // Allow: alphanumeric characters (a-z, A-Z, 0-9), underscore (_), and space
    const pattern = /^[a-zA-Z0-9_ ]$/;
    if (!pattern.test(char)) {
      event.preventDefault();
      return false;
    }
    
    return true;
  }

  // Method to validate product description input (alphanumeric, underscore, and spaces allowed)
  onProductDescKeyPress(event: any): boolean {
    const charCode = event.which || event.keyCode;
    const char = String.fromCharCode(charCode);
    
    // Allow: backspace, delete, tab, escape, enter
    if ([8, 9, 27, 13, 46].indexOf(charCode) !== -1) {
      return true;
    }
    
    // Allow: alphanumeric characters (a-z, A-Z, 0-9), underscore (_), and space
    const pattern = /^[a-zA-Z0-9_ ]$/;
    if (!pattern.test(char)) {
      event.preventDefault();
      return false;
    }
    
    return true;
  }

  typeSelect() {
    this.directData = [];
    this.slabData = [];
    this.selectedDirect = false;
    this.selectedSlab = false;
    this.saveButtonVisible = false;
    this.showOnlySpecific = true;
    console.log(this.addCommissionForm.value.type);
    if (this.addCommissionForm.value.type == "DIRECT") {
      this.saveButtonVisible = true;
      this.selectedDirect = true;
      this.directData = [];
      this.showAddDirectSlabButton = true;
      // this.directTypeData = new TypeDataTable;
      // this.directTypeData.fromAmount = 1;
      // this.directTypeData.toAmount = this.addCommissionForm.value.maxAmount;
      // this.directTypeData.serviceChargeType = "PERCENTAGE";
      // this.directTypeData.serviceCharge = 0;
      // this.directTypeData.isAmountDisabled = true;
      // this.directTypeData.effectiveUpdatedDate = moment().format("MM-DD-YYYY HH:mm");
      // this.directData.push(this.directTypeData);
      // this.gridApi.setRowData(this.directData);
    } else if (this.addCommissionForm.value.type == "SLAB") {
      this.saveButtonVisible = true;
      this.selectedSlab = true;
      this.slabData = [];
      // this.slabTypeData = new TypeDataTable;
      // this.slabTypeData.fromAmount = 1;
      // this.slabTypeData.isAmountDisabled = true;
      // this.slabTypeData.toAmount = this.addCommissionForm.value.maxAmount;
      // this.slabTypeData.serviceChargeType = "PERCENTAGE";
      // this.slabTypeData.serviceCharge = 0;
      // this.slabTypeData.effectiveUpdatedDate = moment().format("MM-DD-YYYY HH:mm");
      // this.slabData.push(this.slabTypeData);
      // this.gridApiSlab.setRowData(this.slabData);
    }
  }

  onGridReadyMaxList(params: GridReadyEvent<any>) {
    console.log("Grid Ready");
    this.gridApi = params.api;
    this.columnApi = params.columnApi;

  }

  onGridReady(params: GridReadyEvent<any>) {
    this.gridApiDirect = params.api
    this.gridApiSlab = params.api

  }

  onRowClicked(param: RowClickedEvent | any) {
    console.log("Row Clicked", param);
  }

  deleteRow(id: number) {
    for (let i: number = 0; i < this.maxAmountData.length; i++) {
      if (this.maxAmountData[i].id == id) {
        this.maxAmountData.splice(i, 1);
        console.log(this.maxAmountData[i]);
        this.countryAmountList.splice(i, 1);
        this.maximumAmount = false;
        this.selectedDirect = false;
        this.selectedSlab = false;
        this.addCommissionForm.controls.type.setValue("");
        this.addCommissionForm.controls.country.setValue(null);
      }
    }
    console.log(this.maxAmountData);
    this.gridApi.setRowData(this.maxAmountData);
    console.log(this.addProductForm.value.countryProduct);
  }

  addDirectSlab(){
    const newRow = { fromAmount: 1, toAmount: this.addCommissionForm.value.maxAmount, serviceChargeType: "PERCENTAGE", serviceCharge: 0, vatType: "PERCENTAGE", vat: 5, effectiveUpdatedDate: moment().format("MM-DD-YYYY HH:mm"),isAmountDisabled: true ,type:"DIRECT" };
    this.directData = [newRow, ...this.directData];
    this.gridApiDirect.setRowData(this.directData);
    this.showAddDirectSlabButton = false;
    return;
  }

  addRow() {
    for(let i:number = 0;i<this.slabData.length;i++){
      if(this.slabData[i].type == "SLAB"){
        const newRow = { fromAmount: 1, toAmount: 0, serviceChargeType: "PERCENTAGE", serviceCharge: 0, vatType: "PERCENTAGE", vat: 5, effectiveUpdatedDate: moment().format("MM-DD-YYYY HH:mm"),isAmountDisabled: false ,type:"SLAB" };
        this.slabData = [newRow, ...this.slabData];
        this.gridApiSlab.setRowData(this.slabData);
        return;
      }
    }
    const newRow = { fromAmount: 1, toAmount: this.addCommissionForm.value.maxAmount, serviceChargeType: "PERCENTAGE", serviceCharge: 0, vatType: "PERCENTAGE", vat: 5, effectiveUpdatedDate: moment().format("MM-DD-YYYY HH:mm"),isAmountDisabled: true ,type:"SLAB"};
    this.slabData = [newRow, ...this.slabData];
    this.gridApiSlab.setRowData(this.slabData);
    return;
  }

  async selectSpecificAmount() {
    let inputSpecificAmount: HTMLInputElement;
    await Swal.fire({
      title: "Please enter the Specific Amount",
      html: '<input type="text" class="swal2-input" id="specificAmount" placeholder="Enter Specific Amount" maxlength="10" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">',
      confirmButtonText: '<span id="confirm-button-text">OK</span>',
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonColor: '#f56d1d',
      cancelButtonColor: '#d33',
      customClass: {
        confirmButton: 'swal2-confirm-custom',
        cancelButton: 'swal2-cancel-custom'
      },
      didOpen:()=>{
        const popup = Swal.getPopup()!
        inputSpecificAmount = popup.querySelector('#specificAmount') as HTMLInputElement
        if (inputSpecificAmount) {
          inputSpecificAmount.style.width = '100%';
          inputSpecificAmount.style.maxWidth = '400px';
          inputSpecificAmount.style.padding = '10px';
          inputSpecificAmount.style.fontSize = '16px';
        }
        inputSpecificAmount.onkeyup = (event) => event.key === 'Enter' && Swal.clickConfirm()
      },
      preConfirm:()=>{
        if(inputSpecificAmount.value != ""){
          console.log(inputSpecificAmount.value);
          if(parseFloat(inputSpecificAmount.value) >= parseFloat(this.addCommissionForm.value.maxAmount)){
            this.alertService.toastWarringMessageAlertWithMessage("Specific amount cannot be greater than max amount");
            return;
          }
          const newRow = { fromAmount: Number(inputSpecificAmount.value), toAmount: Number(inputSpecificAmount.value), serviceChargeType: "PERCENTAGE", serviceCharge: 0, vatType: "PERCENTAGE", vat: 5, effectiveUpdatedDate: moment().format("MM-DD-YYYY HH:mm"),isAmountDisabled: true  ,type:"SPECIFIC AMOUNT"};
          if (this.addCommissionForm.value.type == "DIRECT") {
            for(let i:number = 0;i<this.directData.length;i++){
              if(this.directData[i].fromAmount == this.directData[i].toAmount){
                if(this.directData[i].fromAmount == inputSpecificAmount.value){
                  this.alertService.toastWarringMessageAlertWithMessage("Please enter different specific amount");
                  return;
                }
              }
            }
            this.directData = [...this.directData, newRow];
            this.gridApiSlab.setRowData(this.directData);
          } else {
            for(let i:number = 0;i<this.slabData.length;i++){
              if(this.slabData[i].fromAmount == this.slabData[i].toAmount){
                if(this.slabData[i].fromAmount == inputSpecificAmount.value){
                  this.alertService.toastWarringMessageAlertWithMessage("Please enter different specific amount");
                  return;
                }
              }
            }
            this.slabData = [...this.slabData, newRow];
            this.gridApiSlab.setRowData(this.slabData);
          }
        }else{
          this.alertService.toastWarringMessageAlertWithMessage("Please enter specific amount");
          return;
        }
      },
    });
  }

  async onlySpecificAmount() {
    let inputSpecificAmount: HTMLInputElement;
    await Swal.fire({
      title: "Please enter the Specific Amount",
      html: '<input type="text" class="swal2-input" id="specificAmount" placeholder="Enter Specific Amount" maxlength="10" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">',
      confirmButtonText: '<span id="confirm-button-text">OK</span>',
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonColor: '#f56d1d',
      cancelButtonColor: '#d33',
      customClass: {
        confirmButton: 'swal2-confirm-custom',
        cancelButton: 'swal2-cancel-custom'
      },
      didOpen:()=>{
        const popup = Swal.getPopup()!
        inputSpecificAmount = popup.querySelector('#specificAmount') as HTMLInputElement
        if (inputSpecificAmount) {
          inputSpecificAmount.style.width = '100%';
          inputSpecificAmount.style.maxWidth = '400px';
          inputSpecificAmount.style.padding = '10px';
          inputSpecificAmount.style.fontSize = '16px';
        }
        inputSpecificAmount.onkeyup = (event) => event.key === 'Enter' && Swal.clickConfirm()
      },
      preConfirm:()=>{
        if(inputSpecificAmount.value != ""){
          console.log(inputSpecificAmount.value);
          if(parseFloat(inputSpecificAmount.value) >= parseFloat(this.addCommissionForm.value.maxAmount)){
            this.alertService.toastWarringMessageAlertWithMessage("Specific amount cannot be greater than max amount");
            return;
          }
          const newRow = { fromAmount: Number(inputSpecificAmount.value), toAmount: Number(inputSpecificAmount.value), serviceChargeType: "PERCENTAGE", serviceCharge: 0, vatType: "PERCENTAGE", vat: 5, effectiveUpdatedDate: moment().format("MM-DD-YYYY HH:mm"),isAmountDisabled: true };
          if (this.addCommissionForm.value.type == "DIRECT") {
            this.directData = [];
            this.directData = [...this.directData, newRow];
            this.gridApiSlab.setRowData(this.directData);
            this.showOnlySpecific = false;
            return;
          } else {
            this.slabData = [];
            this.slabData = [...this.slabData, newRow];
            this.gridApiSlab.setRowData(this.slabData);
            this.showOnlySpecific = false;
            return;
          }
        }else{
          this.alertService.toastWarringMessageAlertWithMessage("Please enter specific amount");
          return;
        }
      },
    });
  }



  clearTable(type: string) {
    this.directData = [];
    this.slabData = [];
    this.selectedDirect = false;
    this.selectedSlab = false;
    this.showOnlySpecific = true;
    if (type == "DIRECT") {
      this.selectedDirect = true;
      this.directData = [];
      this.showAddDirectSlabButton = true;
      this.gridApi.setRowData(this.directData);
    } else if (type == "SLAB") {
      this.selectedSlab = true;
      this.slabData = [];
      this.gridApiSlab.setRowData(this.slabData);
    }
  }

  onCellValueChanged(params:any){
    if(params.value == "FLAT" || params.value == "PERCENTAGE"){
      if(this.addCommissionForm.value.type == "DIRECT"){
        this.directData[params.rowIndex].serviceCharge = 0;
        this.gridApiDirect.setRowData(this.directData);
        return;
      }else if(this.addCommissionForm.value.type == "SLAB"){
        this.slabData[params.rowIndex].serviceCharge = 0;
        this.gridApiSlab.setRowData(this.slabData);
        return;
      }
    }

    if(params.column.colId == "serviceCharge"){
      const serviceChargeInput = params.data.serviceCharge;
      if(serviceChargeInput === null || serviceChargeInput === undefined || serviceChargeInput === "" || serviceChargeInput === "."){
        return;
      }
      
      const serviceChargeString = serviceChargeInput.toString().trim();
      const decimalParts = serviceChargeString.split('.');
      if(decimalParts.length > 1 && decimalParts[1].length > 2){
        // Truncate to 2 decimal places without rounding
        const truncatedValue = parseFloat(decimalParts[0] + '.' + decimalParts[1].substring(0, 2));
        if(this.addCommissionForm.value.type == "DIRECT"){
          this.alertService.toastWarringMessageAlertWithMessage("Service Charge can only have up to 2 decimal places");
          this.directData[params.rowIndex].serviceCharge = truncatedValue;
          this.gridApiDirect.refreshCells({ rowNodes: [params.node], force: true });
          return;
        }else if(this.addCommissionForm.value.type == "SLAB"){
          this.alertService.toastWarringMessageAlertWithMessage("Service Charge can only have up to 2 decimal places");
          this.slabData[params.rowIndex].serviceCharge = truncatedValue;
          this.gridApiSlab.refreshCells({ rowNodes: [params.node], force: true });
          return;
        }
      }
      const serviceChargeValue = parseFloat(serviceChargeString);
      
      if(params.data.toAmount == 0 || params.data.toAmount == "0"){
        this.alertService.toastWarringMessageAlertWithMessage("Service Charge cannot be greater than 'To Amount'");
        if(this.addCommissionForm.value.type == "DIRECT"){
          this.directData[params.rowIndex].serviceCharge = 0;
          this.gridApiDirect.setRowData(this.directData);
          return;
        }else if(this.addCommissionForm.value.type == "SLAB"){
          this.slabData[params.rowIndex].serviceCharge = 0;
          this.gridApiSlab.setRowData(this.slabData);
          return;
        }
      }else{
        if(params.data.serviceChargeType == "PERCENTAGE"){
          if(isNaN(serviceChargeValue) || serviceChargeValue < 0){
            if(this.addCommissionForm.value.type == "DIRECT"){
              this.alertService.toastWarringMessageAlertWithMessage("Percentage must be a valid number greater than or equal to 0");
              this.directData[params.rowIndex].serviceCharge = 0;
              this.gridApiDirect.setRowData(this.directData);
              return;
            }else if(this.addCommissionForm.value.type == "SLAB"){
              this.alertService.toastWarringMessageAlertWithMessage("Percentage must be a valid number greater than or equal to 0");
              this.slabData[params.rowIndex].serviceCharge = 0;
              this.gridApiSlab.setRowData(this.slabData);
              return;
            }
          }
          if(serviceChargeValue >= 100){
            if(this.addCommissionForm.value.type == "DIRECT"){
              this.alertService.toastWarringMessageAlertWithMessage("Percentage cannot be 100%. Please enter a value less than 100.");
              this.directData[params.rowIndex].serviceCharge = 0;
              this.gridApiDirect.setRowData(this.directData);
              return;
            }else if(this.addCommissionForm.value.type == "SLAB"){
              this.alertService.toastWarringMessageAlertWithMessage("Percentage cannot be 100%. Please enter a value less than 100.");
              this.slabData[params.rowIndex].serviceCharge = 0;
              this.gridApiSlab.setRowData(this.slabData);
              return;
            }
          }
        }else if(params.data.serviceChargeType == "FLAT"){
          const toAmountValue = parseFloat(params.data.toAmount);
          if(serviceChargeValue > toAmountValue){
            if(this.addCommissionForm.value.type == "DIRECT"){
              this.alertService.toastWarringMessageAlertWithMessage("Service Charge cannot be greater than 'TO AMOUNT'");
              this.directData[params.rowIndex].serviceCharge = 0;
              this.gridApiDirect.setRowData(this.directData);
              return;
            }else if(this.addCommissionForm.value.type == "SLAB"){
              this.alertService.toastWarringMessageAlertWithMessage("Service Charge cannot be greater than 'TO AMOUNT'");
              this.slabData[params.rowIndex].serviceCharge = 0;
              this.gridApiSlab.setRowData(this.slabData);
              return;
            }
          }
        }
      }

    }else if(params.column.colId == "vat"){
      const vatInput = params.data.vat;
      if(vatInput === null || vatInput === undefined || vatInput === "" || vatInput === "."){
        return;
      }
      
      const vatString = vatInput.toString().trim();
      const vatDecimalParts = vatString.split('.');
      if(params.data.vatType == "FLAT"){
        if(vatDecimalParts.length > 1){
          if(this.addCommissionForm.value.type == "DIRECT"){
            this.alertService.toastWarringMessageAlertWithMessage("VAT Flat type only allows whole numbers (0-99)");
            this.directData[params.rowIndex].vat = params.oldValue !== undefined ? params.oldValue : 5;
            this.gridApiDirect.refreshCells({ rowNodes: [params.node], force: true });
            return;
          }else if(this.addCommissionForm.value.type == "SLAB"){
            this.alertService.toastWarringMessageAlertWithMessage("VAT Flat type only allows whole numbers (0-99)");
            this.slabData[params.rowIndex].vat = params.oldValue !== undefined ? params.oldValue : 5;
            this.gridApiSlab.refreshCells({ rowNodes: [params.node], force: true });
            return;
          }
        }
        
        const vatValue = parseFloat(vatString);
        if(isNaN(vatValue)){
          const previousValue = params.oldValue !== undefined ? params.oldValue : 5;
          if(this.addCommissionForm.value.type == "DIRECT"){
            this.directData[params.rowIndex].vat = previousValue;
            this.gridApiDirect.refreshCells({ rowNodes: [params.node], force: true });
            return;
          }else if(this.addCommissionForm.value.type == "SLAB"){
            this.slabData[params.rowIndex].vat = previousValue;
            this.gridApiSlab.refreshCells({ rowNodes: [params.node], force: true });
            return;
          }
        }
        if(vatValue > 99){
          if(this.addCommissionForm.value.type == "DIRECT"){
            this.alertService.toastWarringMessageAlertWithMessage("VAT Flat type only allows 2 digits (0-99)");
            this.directData[params.rowIndex].vat = params.oldValue !== undefined ? params.oldValue : 5;
            this.gridApiDirect.refreshCells({ rowNodes: [params.node], force: true });
            return;
          }else if(this.addCommissionForm.value.type == "SLAB"){
            this.alertService.toastWarringMessageAlertWithMessage("VAT Flat type only allows 2 digits (0-99)");
            this.slabData[params.rowIndex].vat = params.oldValue !== undefined ? params.oldValue : 5;
            this.gridApiSlab.refreshCells({ rowNodes: [params.node], force: true });
            return;
          }
        }
        
        if(vatValue < 0){
          if(this.addCommissionForm.value.type == "DIRECT"){
            this.alertService.toastWarringMessageAlertWithMessage("VAT must be greater than or equal to 0");
            this.directData[params.rowIndex].vat = params.oldValue !== undefined ? params.oldValue : 5;
            this.gridApiDirect.refreshCells({ rowNodes: [params.node], force: true });
            return;
          }else if(this.addCommissionForm.value.type == "SLAB"){
            this.alertService.toastWarringMessageAlertWithMessage("VAT must be greater than or equal to 0");
            this.slabData[params.rowIndex].vat = params.oldValue !== undefined ? params.oldValue : 5;
            this.gridApiSlab.refreshCells({ rowNodes: [params.node], force: true });
            return;
          }
        }
        const wholeNumber = Math.floor(vatValue);
        if(this.addCommissionForm.value.type == "DIRECT"){
          this.directData[params.rowIndex].vat = wholeNumber;
          this.gridApiDirect.refreshCells({ rowNodes: [params.node], force: true });
        }else if(this.addCommissionForm.value.type == "SLAB"){
          this.slabData[params.rowIndex].vat = wholeNumber;
          this.gridApiSlab.refreshCells({ rowNodes: [params.node], force: true });
        }
        return;
      }
      if(vatDecimalParts.length > 1 && vatDecimalParts[1].length > 2){
        const truncatedValue = parseFloat(vatDecimalParts[0] + '.' + vatDecimalParts[1].substring(0, 2));
        if(this.addCommissionForm.value.type == "DIRECT"){
          this.alertService.toastWarringMessageAlertWithMessage("VAT can only have up to 2 decimal places");
          this.directData[params.rowIndex].vat = truncatedValue;
          this.gridApiDirect.refreshCells({ rowNodes: [params.node], force: true });
          return;
        }else if(this.addCommissionForm.value.type == "SLAB"){
          this.alertService.toastWarringMessageAlertWithMessage("VAT can only have up to 2 decimal places");
          this.slabData[params.rowIndex].vat = truncatedValue;
          this.gridApiSlab.refreshCells({ rowNodes: [params.node], force: true });
          return;
        }
      }
      
      const vatValue = parseFloat(vatString);
      if(isNaN(vatValue)){
        const previousValue = params.oldValue !== undefined ? params.oldValue : 5;
        if(this.addCommissionForm.value.type == "DIRECT"){
          this.directData[params.rowIndex].vat = previousValue;
          this.gridApiDirect.refreshCells({ rowNodes: [params.node], force: true });
          return;
        }else if(this.addCommissionForm.value.type == "SLAB"){
          this.slabData[params.rowIndex].vat = previousValue;
          this.gridApiSlab.refreshCells({ rowNodes: [params.node], force: true });
          return;
        }
      }
      
      if(vatValue < 0){
        if(this.addCommissionForm.value.type == "DIRECT"){
          this.alertService.toastWarringMessageAlertWithMessage("VAT must be greater than or equal to 0");
          this.directData[params.rowIndex].vat = params.oldValue !== undefined ? params.oldValue : 5;
          this.gridApiDirect.refreshCells({ rowNodes: [params.node], force: true });
          return;
        }else if(this.addCommissionForm.value.type == "SLAB"){
          this.alertService.toastWarringMessageAlertWithMessage("VAT must be greater than or equal to 0");
          this.slabData[params.rowIndex].vat = params.oldValue !== undefined ? params.oldValue : 5;
          this.gridApiSlab.refreshCells({ rowNodes: [params.node], force: true });
          return;
        }
      }
      
      if(params.data.vatType == "PERCENTAGE"){
        if(vatValue >= 100){
          if(this.addCommissionForm.value.type == "DIRECT"){
            this.alertService.toastWarringMessageAlertWithMessage("VAT Percentage cannot be 100% or greater. Please enter a value less than 100.");
            this.directData[params.rowIndex].vat = params.oldValue !== undefined ? params.oldValue : 5;
            this.gridApiDirect.refreshCells({ rowNodes: [params.node], force: true });
            return;
          }else if(this.addCommissionForm.value.type == "SLAB"){
            this.alertService.toastWarringMessageAlertWithMessage("VAT Percentage cannot be 100% or greater. Please enter a value less than 100.");
            this.slabData[params.rowIndex].vat = params.oldValue !== undefined ? params.oldValue : 5;
            this.gridApiSlab.refreshCells({ rowNodes: [params.node], force: true });
            return;
          }
        }
      }
    }else{
      return;
    }
}


}
